import { appService } from "../services/app-service.ts";

export const appRepo = {
    getGateways: async (page: number) => {
        return await appService.getGateways(page);
    },
    getGateway: async (id: number) => {
        return await appService.getGateway(id);
    },
    createGateway: async (gateway: Parameters<typeof appService.createGateway>[0]) => {
        return await appService.createGateway(gateway);
    },
    updateGateway: async (id: number, gateway: Parameters<typeof appService.updateGateway>[1]) => {
        return await appService.updateGateway(id, gateway);
    },
    getDiscounts: async (page: number) => {
        return await appService.getDiscounts(page);
    },
    getDiscount: async (id: number) => {
        return await appService.getDiscount(id);
    },
    createDiscount: async (discount: Parameters<typeof appService.createDiscount>[0]) => {
        return await appService.createDiscount(discount);
    },
    updateDiscount: async (id: number, discount: Parameters<typeof appService.updateDiscount>[1]) => {
        return await appService.updateDiscount(id, discount);
    },
    deleteDiscount: async (id: number) => {
        return await appService.deleteDiscount(id);
    },
    getPlans: async (page: number) => {
        return await appService.getPlans(page);
    },
    getPlan: async (id: number) => {
        return await appService.getPlan(id);
    },
    createPlan: async (plan: Parameters<typeof appService.createPlan>[0]) => {
        return await appService.createPlan(plan);
    },
    updatePlan: async (id: number, plan: Parameters<typeof appService.updatePlan>[1]) => {
        return await appService.updatePlan(id, plan);
    },
    deletePlan: async (id: number) => {
        return await appService.deletePlan(id);
    },
    getTickets: async (page: number, status: string, priority: string) => {
        return await appService.getTickets(page, status, priority);
    },
    getTicketMessages: async (id: number) => {
        return await appService.getTicketMessages(id);
    },
    replyToTicket: async (id: number, reply: Parameters<typeof appService.replyToTicket>[1]) => {
        return await appService.replyToTicket(id, reply);
    },
    getPayments: async (page: number, limit?: number) => {
        return await appService.getPayments(page, limit);
    },
    approvePayment: async (id: number) => {
        return await appService.approvePayment(id);
    },
    rejectPayment: async (id: number) => {
        return await appService.rejectPayment(id);
    },
    getDonations: async (page: number, limit?: number, status?: Parameters<typeof appService.getDonations>[2]) => {
        return await appService.getDonations(page, limit, status);
    },
    getReports: async (page: number, status?: 'resolved' | 'not_resolved') => {
        return await appService.getReports(page, status);
    },
    resolveReport: async (id: number) => {
        return await appService.resolveReport(id);
    },
    uploadImage: async (file: File) => {
        return await appService.uploadImage(file);
    },
    getImages: async (page: number) => {
        return await appService.getImages(page);
    },
    deleteImages: async (urls: string[]) => {
        return await appService.deleteImages(urls);
    },
    getSettings: async () => {
        return await appService.getSettings();
    },
    updateSettings: async (settings: Parameters<typeof appService.updateSettings>[0]) => {
        return await appService.updateSettings(settings);
    },
    getAppVersions: async (page: number) => {
        return await appService.getAppVersions(page);
    },
    getAppVersion: async (id: number) => {
        return await appService.getAppVersion(id);
    },
    createAppVersion: async (appVersion: Parameters<typeof appService.createAppVersion>[0]) => {
        return await appService.createAppVersion(appVersion);
    },
    updateAppVersion: async (id: number, appVersion: Parameters<typeof appService.updateAppVersion>[1]) => {
        return await appService.updateAppVersion(id, appVersion);
    },
    deleteAppVersion: async (id: number) => {
        return await appService.deleteAppVersion(id);
    },
};